<ng-container *transloco="let t">
	<ng-container *ngIf="data.dismissible">
		<div class="absolute top-0 right-0 pt-4 pr-4">
			<button mat-icon-button [matDialogClose]="undefined">
				<mat-icon class="text-secondary" svgIcon="mat_outline:close"></mat-icon>
			</button>
		</div>
	</ng-container>
	<mat-dialog-content>
		<div class="flex flex-col p-4 pb-2 pt-6 sm:pb-4 gap-6" *ngIf="data">
		<div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start ">
			<ng-container *ngIf="data.icon?.name">
				<div class="flex flex-0 items-center justify-center sm:mr-4 " [ngClass]="{'text-primary-600': data.icon.color === 'primary',
                            'text-accent-600': data.icon.color === 'accent',
                            'text-warn-600': data.icon.color === 'warn',
                            'text-gray-600': data.icon.color === 'basic',
                            'text-blue-600': data.icon.color === 'info',
                            'text-green-500': data.icon.color === 'success',
                            'text-amber-500': data.icon.color === 'warning',
                            'text-red-600': data.icon.color === 'error'
                            }">
					<mat-icon class="text-current icon-size-8" [svgIcon]="data.icon.name"></mat-icon>
				</div>
			</ng-container>
			<ng-container *ngIf="data.title || data.message">
				<div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
					<ng-container *ngIf="data.title">
						<div class="text-xl leading-6 font-medium text-slate-900 dark:text-white">{{data.title}}</div>
					</ng-container>

					<ng-container *ngIf="data.message">
						<div class="text-secondary">{{data.message}}</div>
					</ng-container>
				</div>
			</ng-container>



		</div>

		@if(data.type === 'input'){
			<mat-form-field class="fuse-mat-dense w-full" hideRequiredMarker="true">
				@if(data.label){<mat-label>{{data.label}}</mat-label>}
				<input matInput type="text" [(ngModel)]="result.text" name="text" #text="ngModel" [required]="data.required"	cdkFocusInitial>
				@if(text.hasError('required') && text.touched){
				<mat-error> {{data.label}} {{t('is required')}}
				</mat-error>
				}
			</mat-form-field>
			}
	</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">

		<button mat-raised-button (click)="confirm({action: 'ignore'})" *ngIf="ignoreButton">{{t('Ignore')}}</button>
		<button mat-raised-button (click)="confirm({action: 'no'})" *ngIf="noButton">{{t('No')}}</button>
		<button mat-raised-button (click)="confirm({action: 'noSave'})" *ngIf="noSaveButton">{{t('NoSave')}}</button>
		<button mat-raised-button (click)="confirm({action: 'cancel'})" *ngIf="cancelButton">{{t('Cancel')}}</button>

		<button mat-raised-button (click)="confirm({action: 'abort'})" *ngIf="abortButton"
			id="abort">{{t('Abort')}}</button>
		<button mat-raised-button (click)="confirm({action: 'confirm'})" [color]="data?.confirm?.color"
			*ngIf="confirmButton" id="confirm" [disabled]="data.type === 'input' && !result?.text?.length">{{t('Confirm')}}</button>
		<button mat-raised-button (click)="confirm({action: 'ok'})" [color]="data?.confirm?.color" *ngIf="okButton"
			id="ok" [disabled]="data.type === 'input' && !result?.text?.length">{{t('Ok')}}</button>
		<button mat-raised-button (click)="confirm({action: 'save'})" [color]="data?.confirm?.color" *ngIf="saveButton"
			id="save" [disabled]="data.type === 'input' && !result?.text?.length">{{t('Save')}}</button>
		<button mat-raised-button (click)="confirm({action: 'yes'})" [color]="data?.confirm?.color" *ngIf="yesButton"
			id="yes" [disabled]="data.type === 'input' && !result?.text?.length">{{t('Yes')}}</button>
		<button mat-raised-button (click)="confirm({action: 'retry'})" [color]="data?.confirm?.color" *ngIf="retryButton"
			id="retry" [disabled]="data.type === 'input' && !result?.text?.length">{{t('Retry')}}</button>

	</mat-dialog-actions>
</ng-container>
